import CardButton from 'components/CardButton'
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import CardNews from 'components/CardNews';
import Slider from 'react-slick';
import { getProfile } from 'services/apiRoutes';
import SkeletonNews from 'skeletons/SkeletonNews';

export default function Capaian() {
  const [capaian, setCapaian] = useState();
  const { slug } = useParams();


  const profileAPI = useCallback(async () => {
    const res = await getProfile(slug);
    if (res.error) {
      return res.message;
    } else {
      const { data } = res.data;
      setCapaian(data.CapaianGampong);
    }
  }, [slug]);

  useEffect(() => {
    profileAPI();
  }, [profileAPI]);


  const navigate = useNavigate();
  // const settings = {
  //   className: "center",
  //   centerMode: true,
  //   infinite: true,
  //   slidesToShow: 6,
  //   slidesToScroll: 3,
  //   autoplay: true,
  //   speed: 2000,
  //   autoplaySpeed: 2000,
  //   cssEase: "linear",
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 3,
  //       },
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //       },
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //       },
  //     },
  //   ],
  // };
  const settings = {
    // dots: true,
    infinite: true,
    speed: 500,
      autoplay: true,
      autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 3,
    adaptiveHeight: true,
    // arrows: true,
    // nextArrow: <ArrowButton right />,
    // prevArrow: <ArrowButton />,
    // dotsClass: "button__bar",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // arrows:true
        },
      },
    ],
  };
  return (
    <div className="px-5 space-y-16 xl:px-99">
      <div className="flex items-center justify-between warpperButton">
        <h1 className="text-base font-bold md:text-3xl">Gallery Gampong</h1>
        <div className="buttonWrapped">
          <CardButton
            label="Selengkapnya"
            onClick={() => navigate(`/${slug}/pencapaian`)}
          />
        </div>
      </div>
      <Slider {...settings}>
        {capaian
          ? capaian.map(
              (item, index) =>
                index <= 5 && (
                  <CardNews
                    onlanding
                    gallery
                    img={item?.url_gambar}
                    label={
                      item?.list_kategori_capaian_obj[index]
                        ? item?.list_kategori_capaian_obj[index]?.kategori_obj
                            ?.nama
                        : ""
                    }
                    title={item?.nama}
                    // onClick={() => navigate(`/PostBerita/${item.uuid}`)}
                  />
                ))
          : [1, 2,3].map((i) => (
                <SkeletonNews key={i} />
            ))}
      </Slider>
    </div>
  );
}
